import React, { useEffect, useState, FC } from 'react'
import { InputProps } from 'antd/lib/input/Input'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { Input } from 'antd'
import styled from '@emotion/styled'
import classNames from 'classnames'

const DDInput: FC<InputProps> = ({ ...props }) => {
  return <StyledDDInput {...props} />
}

const StyledDDInput = styled(Input)`
  width: 237px;
  height: 36px;
  line-height: 36px;
  background: var(--dd-input-bg-color);
  border-radius: 4px;
  border: 1px solid var(--dd-input-border-color);
  color: var(--text-color-1);
  &::placeholder {
    color: var(--text-color-2);
    font-size: var(--fontsize-12);
  }
  &:focus,
  &:hover {
    border-color: var(--main-color);
  }
  &:focus {
    box-shadow: var(--dd-input-shadow-color);
  }
`

export default hot(observer(DDInput))
